import axiosClient from '@/config/api/axios'
import { AUTOMATIONS, SCHEDULES, TRIGGERS } from '@/config/api/endpoints'
import { isApiConfigured } from '@/config/api/env'
import { automationFromRow, scheduleAutomationsFromRow } from './automationMapper'

async function list(path, mapper, signal) {
  if (!isApiConfigured()) return []
  const { data } = await axiosClient.get(path, { signal })
  return (Array.isArray(data) ? data : []).map(mapper)
}

export const fetchAutomations = ({ signal } = {}) => list(AUTOMATIONS, automationFromRow, signal)
export const fetchSchedules = async ({ signal } = {}) => {
  const rows = await list(SCHEDULES, (row) => row, signal)
  return rows.flatMap(scheduleAutomationsFromRow)
}
export const fetchTriggers = ({ signal } = {}) => list(TRIGGERS, automationFromRow, signal)
